const AdministratorSettingsPage = () => import('client/settings/AdministratorSettings/AdministratorSettingsPage.vue');
const EmailCustomizationPage = () => import('client/settings/EmailCustomization/EmailCustomizationPage.vue');
const FeatureSettingsPage = () => import('client/settings/FeatureSettings/FeatureSettingsPage.vue');
const MfaMainPanel = () => import('client/MFA/MfaMainPanel.vue');
const OrganizationProfilePage = () => import('client/settings/OrganizationProfile/OrganizationProfilePage.vue');
const SecurityPage = () => import('client/settings/Security/SecurityPage.vue');
const SettingsPage = () => import('client/settings/SettingsPage.vue');
const UserManagementPage = () => import('client/systemusers/SystemUserItemTable/UserManagement/UserManagementPage.vue');

const defaultMeta = {
  hideImplementationChecklist: true,
  loadLegacyStyles: false,
};

export default [
  {
    path: '/settings/',
    name: 'Settings',
    meta: {
      ...defaultMeta,
      title: 'Settings',
    },
    redirect: { name: 'Organization Profile' },
    components: {
      mainPanel: SettingsPage,
    },
    children: [
      {
        path: 'organization',
        name: 'Organization Profile',
        component: OrganizationProfilePage,
        meta: {
          ...defaultMeta,
          title: 'Settings',
        },
      },
      {
        path: 'security',
        name: 'Security Settings',
        component: SecurityPage,
        meta: {
          ...defaultMeta,
          title: 'Settings',
        },
      },
      {
        path: 'administrators',
        name: 'Administrator Settings',
        component: AdministratorSettingsPage,
        meta: {
          ...defaultMeta,
          title: 'Settings',
        },
        children: [
          {
            path: 'new',
            name: 'Administrator Settings Create',
            component: AdministratorSettingsPage,
            meta: {
              ...defaultMeta,
              title: 'Settings',
              view: 'create',
            },
          },
          {
            path: 'details/:itemId',
            name: 'Administrator Settings Edit',
            component: AdministratorSettingsPage,
            meta: {
              ...defaultMeta,
              title: 'Settings',
              view: 'update',
            },
          },
        ],
      },
      {
        path: 'user',
        name: 'User Management',
        component: UserManagementPage,
        meta: {
          ...defaultMeta,
          title: 'Settings',
        },
      },
      {
        path: 'email',
        name: 'Customize Email',
        component: EmailCustomizationPage,
        meta: {
          ...defaultMeta,
          title: 'Settings',
        },
      },
      {
        path: 'features',
        name: 'Feature Settings',
        component: FeatureSettingsPage,
        meta: {
          ...defaultMeta,
          title: 'Settings',
        },
      },
      // Redirects for old links
      {
        path: 'general',
        name: 'Settings General',
        redirect: { name: 'Organization Profile' },
      },
    ],
  },
  // Old Routes not included in tabbed page currently.
  {
    path: '/settings/mfa',
    name: 'Settings MFA',
    meta: {
      title: 'MFA Configurations',
    },
    components: {
      mainPanel: MfaMainPanel,
    },
  },
];
